/** Lightweight markdown → safe HTML for Tiago bubbles */
function escapeHtml(s) {
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

export function renderTiagoMarkdown(text) {
  let html = escapeHtml(text || '');
  html = html.replace(/```([\s\S]*?)```/g, '<pre class="tiago-code"><code>$1</code></pre>');
  html = html.replace(/`([^`]+)`/g, '<code class="tiago-inline-code">$1</code>');
  html = html.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
  html = html.replace(/\*([^*]+)\*/g, '<em>$1</em>');
  html = html.replace(/^(#{1,3})\s+(.+)$/gm, (_, hashes, t) => {
    const level = hashes.length;
    return `<h${level + 2} class="tiago-md-h">${t}</h${level + 2}>`;
  });
  html = html.replace(/\n/g, '<br>');
  return html;
}

export function messagesToMarkdown(messages, title = 'Tiago chat') {
  const lines = [`# ${title}`, ''];
  for (const m of messages) {
    const who = m.sender === 'user' ? 'You' : 'Tiago';
    lines.push(`**${who}:** ${m.text}`, '');
  }
  return lines.join('\n');
}
